import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DownloadDto } from '../_models/downloaddto';
import { DownloadService } from '../_services/download.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.css'],
    standalone: false
})
export class DownloadComponent implements OnInit {
  downloads$: Observable<DownloadDto[]>;
  baseUrl = environment.apiUrl + "download/";
  constructor(private downloadService: DownloadService) { }

  ngOnInit(): void {
    this.downloads$ = this.downloadService.getAll();
    
  }

  

}
